module.exports = __webpack_public_path__ + "static/img/banner02.730e489a.webp";